export async function getRecaptchaToken(action: string): Promise<string> {
    return new Promise((resolve: (token: string) => void) => {
        window.grecaptcha.enterprise.ready(function handleRecaptchaApiReady() {
            window.grecaptcha
                .enterprise
                .execute(window.app.config.recaptcha.publicKey, { action })
                .then(function handleRecaptchaTokenResponse(token: string) {
                    resolve(token);
                })
                .catch((error: Error) => {
                    console.error(error);
                    throw new Error('Failed to get recaptcha token');
                });
        });
    });
}

export function getIsRecaptchaEnabled(): boolean {
    return window.app.config?.recaptcha?.isOn === true;
}
